import React from 'react';
import { useLocation } from 'react-router-dom';
import { useWaterSystemSearchModal } from '../../../reuseableComponents/WaterSystemSearchModalContext';
import useDwriData from '../../../../hooks/engineering/water_use/useDwriData';
import DwriSystemHeader from './sections/DwriSystemHeader';
import DwriManagementInfo from './sections/DwriManagementInfo';
import DwriAnnualUseSection from './sections/DwriAnnualUseSection';
import DwriPeakDaySection from './sections/DwriPeakDaySection';
import DwriPeakMonthSection from './sections/DwriPeakMonthSection';
import DwriSourceDataSection from './sections/DwriSourceDataSection';
import '../dwri.css';

const DwriDataTab = () => {
    const location = useLocation();
    const { selectedYears = [], selectedSources = [], yearOptions = [] } = location.state || {};

    let formattedYears = selectedYears.map(year => parseInt(year, 10));
    if (formattedYears.length === 0) {
        formattedYears = [...yearOptions].sort((a, b) => b - a).slice(0, 5);
    }

    const { selectedWaterSystem } = useWaterSystemSearchModal();

    const {
        systemName,
        sizingInfo,
        waterUses,
        sourceRecords,
        peakDayData,
        peakMonthData,
        loading,
        errors,
    } = useDwriData({
        pwsId: selectedWaterSystem?.pwsId,
        years: formattedYears,
        selectedSources,
    });

    return (
        <div className="utah-design-system">
            <DwriSystemHeader
                systemName={systemName}
                loading={loading.info}
            />
            <DwriManagementInfo
                sizingInfo={sizingInfo}
                loading={loading.info}
                error={errors.info}
            />
            <br />
            <DwriAnnualUseSection
                waterUses={waterUses}
                loading={loading.annualUse}
                error={errors.annualUse}
            />
            <DwriPeakDaySection
                peakDayData={peakDayData}
                loading={loading.peak}
                error={errors.peak}
            />
            <DwriPeakMonthSection
                peakMonthData={peakMonthData}
                loading={loading.peak}
                error={errors.peak}
            />
            <DwriSourceDataSection
                sourceRecords={sourceRecords}
                selectedSources={selectedSources}
                loading={loading.annualUse}
                error={errors.annualUse}
            />
        </div>
    );
};

export default DwriDataTab;
